import WebinaireItem from "./WebinaireItem";
import { Webinaire } from "../../lib/interfaces/webinaire.interface";
import { Inbox } from "lucide-react";

interface Props {
  webinaires: Webinaire[];
  disableLiveAfterFirst?: boolean;
}

export default function WebinaireList({ webinaires, disableLiveAfterFirst = false }: Props) {
  if (webinaires.length === 0) {
    return (
      <div className="flex flex-col items-center px-5 py-12 text-center text-slate-500">
        <Inbox className="mb-3 h-8 w-8 text-slate-300" />
        <span className="font-medium text-slate-700">Aucun webinaire à afficher</span>
        <span className="mt-1 text-sm">Les nouvelles dates apparaîtront ici.</span>
      </div>
    );
  }

  return (
    <div className="divide-y divide-slate-100">
      {webinaires.map((webinaire, index) => (
        <WebinaireItem
          key={webinaire.id}
          titre={webinaire.titre}
          date={webinaire.date}
          replayUrl={webinaire.replayUrl}
          intervenants={webinaire.intervenants}
          liveUrl={webinaire.liveUrl}
          description={webinaire.description}
          heureDebut={webinaire.heureDebut}
          heureOuvertureAcces={webinaire.heureOuvertureAcces}
          disableLive={disableLiveAfterFirst && index > 0}
        />
      ))}
    </div>
  );
}
